/**
 * Доменні типи продукту.
 *
 * Головний принцип: у коді немає жодної «зашитої» назви підрозділу, посади,
 * звання, прийому їжі чи типу позначки — усе це дані, які редагуються у вебі.
 */
/** Ролі користувачів, від найширшої до найвужчої. */
export const USER_ROLES = ['owner', 'admin', 'clerk'];
/* ---------------------------------------------------------------- позначки */
/**
 * Шари клітинки. Клітинка тримає по одній позначці на шар, тож шар — це те,
 * що може стояти в одному дні одночасно: харчування, підказка, наряд і
 * відсутність.
 */
export const MARK_LAYERS = ['main', 'hint', 'duty', 'away'];
/* ------------------------------------------------------------- документи */
export const TEMPLATE_KINDS = [
    'report',
    'leaveReport',
    'dutyReport',
    'bonusReport',
    'canteenList',
    'leaveList',
    'overnightList',
    'monthTable',
    'custom',
];
//# sourceMappingURL=types.js.map